import { ContactButtonClickType } from '../type';
import { MembershipApiS } from '../outbound/share';
import { MShopAppStoreQuestionF } from '../../../../../modules/MShop/App/Store/Question/F/Function/module/MShopAppStoreQuestionF';
import { loading, loadingEnd } from '../../../shared/client/global';
import { COMMISSION, MEMBERSHIP, SUPPORT } from '../constant';

/**
 * SDK CALLBACK: 문의하기 모달창 열기
 */
export const onContactButtonClick =
  ({ type, support_id, membership_id, commission_request_id, validationHook }: ContactButtonClickType) =>
  async (project_id: string, commission_id?: string) => {
    // 현재 로그인된 유저정보
    const user = box.sel('is_user') as { id: number };

    loading();
    const { data } = await MembershipApiS.getStoreIdByProjectId(project_id);

    // Fixme: @parkbyeonghoon222 데이터 쌓이면 해당 콘솔로그 삭제하기
    if (!data) {
      loadingEnd();
      throw new Error('해당 projectId 에 맵핑된 store_id 가 없습니다.');
    }

    if (validationHook && (await validationHook())) {
      return;
    }

    loadingEnd();

    if (type === MEMBERSHIP) {
      await MShopAppStoreQuestionF.open({ user, store_id: data.store_id, type, membership_id });
    } else if (type === SUPPORT) {
      await MShopAppStoreQuestionF.open({ user, store_id: data.store_id, type, support_id });
    } else if (type === COMMISSION) {
      await MShopAppStoreQuestionF.open({
        user,
        store_id: data.store_id,
        type,
        commission_id,
        commission_request_id,
      });
    }
  };
